<template>
  <div v-if="isLoading" class="overlay-loader">
    <img src="../assets/img/ajax-loader.gif" alt="loading data..." />
  </div>
</template>

<script>
export default {
  name: "OverlayLoader",
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.overlay-loader {
  position: absolute;
  z-index: 500;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff99;
}

.overlay-loader > img {
  margin-bottom: 10%;
  height: 50px;
  width: 50px;
}
</style>